import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import { darkTheme } from '../allimports.js'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    const navigate = useNavigate();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
      if (data.get("email")=='admin' || data.get("password")=='earthi') {
     
      navigate('/home');
      } else {

        alert('Incorrect email or password');
      }
  
    console.log({
      email: data.get("email"),
      password: data.get("password"),
    });
  };

  return (
      <ThemeProvider theme={darkTheme}>
       
       <Container component="main" maxWidth="sm">
      <Box
        sx={{
          boxShadow: 8,
          borderRadius: 8,
          px: 4,
          py: 6,
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <Box  sx={{ mb: 6 }}>
        <img src="/app/earthi-rev2_grey.png" alt="Earthi" width='200px'/>

            <img src="/app/logo.png" alt="Logo" width='200px'/>

        </Box>
        <Typography component="h1" variant="h4">
          Earth-i Aircraft Monitoring
        </Typography>
        <br />
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
           <br />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
           <br />
          <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>

        </Box>
      </Box>
    </Container>

    </ThemeProvider>
  );
}